angular.module('app').directive('qrcodeGenerator', function() {
	return {
        restrict: 'E',
        scope:{
            url:'@',
        },
        template: `<div class="qrcode-output"></div>`,
        controller: function($scope, $timeout) {
            $scope.init = function(el){
                var qrcode = new QRCode(el.find(".qrcode-output")[0], {
                    text: $scope.url,
                    width: 128,
                    height: 128,
                    colorDark : "#000000",
                    colorLight : "#ffffff",
                    correctLevel : QRCode.CorrectLevel.H
                });

                qrcode.makeCode( $scope.url );
            }
        },
        link: function ($scope, $element, attrs, ctrl) {
            $scope.init($element);
        }
    };
})